<div class="container">
  <div class="page-bg">
    <ng-container *ngIf="service.advService.bannersEnabled">
      <div class="adsContainer" *ngIf="!isPremium || !service.enableSubscription">
        <app-banner-zone-map [zoneType]="['Desktop-Zone-Horizontal-Top', 'Desktop-Zone-Horizontal-Bottom']" ></app-banner-zone-map>
      </div>
    </ng-container>
    <div class="row w-100 adv-user p-2">
          <div class="col-md-6 col-sm-12">
            <mat-button-toggle-group
              style="float: left"
              *ngIf="!this.service.userService.isDemo()"
            >
              <mat-button-toggle
                class="mat-adv_tab_btn"
                value="ACTIVE"
                (change)="setViewMode($event.value)"
                [checked]="this.viewModeIsActive()"
                >Active</mat-button-toggle
              >
              <mat-button-toggle
                class="mat-adv_tab_btn"
                value="EXPIRED"
                (change)="setViewMode($event.value)"
                [checked]="this.viewModeIsExpired()"
                >Expired</mat-button-toggle
              >
            </mat-button-toggle-group>
          </div>
          <div class="col-md-6 col-sm-12">
            <mat-paginator
              (page)="pageEvent = $event"
              [length]="length"
              [pageIndex]="pageNumber"
              [pageSizeOptions]="pageSizeOptions"
              [pageSize]="pageSize"
            ></mat-paginator>
          </div>
        </div> 
      <div class="w-100 pl-3 pr-3 pb-3">
        <div class="checker" *ngFor="let card of cardList">
          <!-- material card here -->
          <app-adv-small
            (click)="openAdv(card.advertisementId)"
            [Date]="card.dateStart"
            [Description]="card.content"
            [DisplayMode]="listLayoutType.ROW"
            [Expired]="advIsExpired(card)"
            [ImageUrl]="getImageFromCard(card)"
            [Title]="card.title"
            [IsPremium]="card.isPremium"
            [IsThirdParty]="card.isThirdParty"
            [PremiumText] ="getPremiumText(card)"
            (AdvShouldBeReposted)="repostAdv(card)"
          >
          </app-adv-small>
        </div>
      </div>
    </div>
  </div>

